__turbopack_context__.v({
  "grabCursor": "GrabCursorLabel-module-scss-module__FSEbSq__grabCursor",
  "label": "GrabCursorLabel-module-scss-module__FSEbSq__label",
});
